import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetKitsQueryVariables = Types.Exact<{
  siteId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.KitDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.KitDocumentSortInput> | Types.KitDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetKitsQuery = { __typename?: 'Query', kits?: { __typename?: 'KitsConnection', totalCount: number, nodes?: Array<{ __typename?: 'KitDocument', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineDocument', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetKitQueryVariables = Types.Exact<{
  kitId: Types.Scalars['String']['input'];
}>;


export type GetKitQuery = { __typename?: 'Query', kit?: { __typename?: 'KitDocument', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineDocument', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> } | null };

export type KitSummaryFragment = { __typename?: 'KitDocument', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineDocument', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> };

export type KitLineSummaryFragment = { __typename?: 'KitLineDocument', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null };

export type KitStateFragment = { __typename?: 'KitStateData', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineStateData', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> };

export type KitLineStateFragment = { __typename?: 'KitLineStateData', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null };

export const KitLineSummaryFragmentDoc = new TypedDocumentString(`
    fragment KitLineSummary on KitLineDocument {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}
    `, {"fragmentName":"KitLineSummary"});
export const KitSummaryFragmentDoc = new TypedDocumentString(`
    fragment KitSummary on KitDocument {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineSummary
  }
}
    fragment KitLineSummary on KitLineDocument {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`, {"fragmentName":"KitSummary"});
export const KitLineStateFragmentDoc = new TypedDocumentString(`
    fragment KitLineState on KitLineStateData {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}
    `, {"fragmentName":"KitLineState"});
export const KitStateFragmentDoc = new TypedDocumentString(`
    fragment KitState on KitStateData {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineState
  }
}
    fragment KitLineState on KitLineStateData {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`, {"fragmentName":"KitState"});
export const GetKitsDocument = new TypedDocumentString(`
    query GetKits($siteId: String, $search: String, $where: KitDocumentFilterInput, $order: [KitDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  kits(
    siteId: $siteId
    search: $search
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...KitSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment KitSummary on KitDocument {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineSummary
  }
}
fragment KitLineSummary on KitLineDocument {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetKitDocument = new TypedDocumentString(`
    query GetKit($kitId: String!) {
  kit(kitId: $kitId) {
    ...KitSummary
  }
}
    fragment KitSummary on KitDocument {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineSummary
  }
}
fragment KitLineSummary on KitLineDocument {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetKits: build.query<GetKitsQuery, GetKitsQueryVariables | void>({
      query: (variables) => ({ document: GetKitsDocument, variables })
    }),
    GetKit: build.query<GetKitQuery, GetKitQueryVariables>({
      query: (variables) => ({ document: GetKitDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetKitsQuery, useLazyGetKitsQuery, useGetKitQuery, useLazyGetKitQuery } = injectedRtkApi;
